<template>
  <div :class="['search-track', {'show-on-load':showOnLoad}]">
    <div class="abs-center">
      <div class="card medium-margin-v-s">
        <h3 class="margin-t-z margin-b-s">{{ $t('searchTrack.trackVehicle') }}</h3>
        <div class="description">{{ $t('searchTrack.followInfo') }}:</div>
        <form @submit.prevent="submit">
          <div class="row">
            <div class="large-4 column ">
              <div v-bind:class="['field-group' + ( validation.rsvpNumber ? '': ' field-error')]">
                <input class="field-text" ref="ReservationNumberInput" type="text" v-model="rsvpNumber"
                  :placeholder="$t('searchTrack.rsvpNumber')" @keypress="validation.rsvpNumber = true" />
                <label class="field-error-message">
                  {{ $t('searchTrack.isRequired') }}
                </label>
              </div>
            </div>
            <div class="large-4 column padding-l-s medium-padding-h-z">
              <div v-bind:class="['field-group' + ( validation.firstName ? '': ' field-error')]">
                <input class="field-text" type="text" v-model="firstName" :placeholder="$t('searchTrack.firstName')" @keypress="validation.firstName = true" />
                <label class="field-error-message">
                  {{ $t('searchTrack.isRequired') }}
                </label>
              </div>
            </div>
            <div class="large-4 column padding-l-s medium-padding-h-z">
              <div v-bind:class="['field-group' + ( validation.lastName ? '': ' field-error')]">
                <input class="field-text" type="text" v-model="lastName" :placeholder="$t('searchTrack.lastName')" @keypress="validation.lastName = true" />
                <label class="field-error-message">
                  {{ $t('searchTrack.isRequired') }}
                </label>
              </div>
            </div>
          </div>
          <div v-bind:class="{ 'error-message': true, hide: !error.show }">{{ error.message }}</div>
          <div class="controls">
            <a href="#/search" class="op-btn btn-lg" @click="cancel($event)">{{ $t('common.cancel') }}</a>
            <a href="#/rsvp-track" :class="['op-btn btn-success btn-lg btn-continue', {disabled: isSearching}]"
              @click="submitTrack($event)">
              <i class="fa fa-spinner fa-spin" v-show="isSearching"></i>
              <span v-show="!isSearching">{{ $t('common.continue') }}</span>
            </a>
            <button type="submit" ref="submitBtn" v-show="false"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
/* global CONFIG */
import moment from 'moment'
import ft from '@/modules/api/featureToggle'
import ApiRsvpSearch from '@/modules/api/reservation-search'

export default {
  name: 'search-edit',
  data () {
    return {
      rsvpNumber: '',
      firstName: '',
      lastName: '',
      isSearching: false,
      validation: {
        rsvpNumber: true,
        firstName: true,
        lastName: true
      },
      error: {
        show: false,
        message: ''
      },
      showOnLoad: false
    }
  },
  computed: {
    _brandId () { return this.$store.state.brandId },
    route () { return this.$route.name }
  },
  methods: {
    cancel (event) {
      if (event) event.preventDefault()
      // let loc = window.location.href
      // let index = loc.indexOf('#')
      // window.location = loc.substring(0, index) + '#'
      this.$store.commit('reservation/setCharterData', {
        enabled: false,
        pickup: {},
        startDate: '',
        endDate: '',
        selectedService: ''
      })

      this.$root.$emit('close')
      this.$root.$router.push('search')
      window.location.href = '#/search'
    },
    onKeyPress () {
      // console.log(this.rsvpNumber)
    },
    isValid () {
      let self = this
      self.validation.rsvpNumber = true
      self.validation.firstName = true
      self.validation.lastName = true
      let result = true
      if (self.rsvpNumber === '') {
        self.validation.rsvpNumber = false
        result = false
      }
      if (self.firstName === '') {
        self.validation.firstName = false
        result = false
      }
      if (self.lastName === '') {
        self.validation.lastName = false
        result = false
      }
      return result
    },
    submit () {
      let self = this
      self.error = {
        show: false,
        message: ''
      }
      if (!self.isValid()) return

      self.isSearching = true
      ApiRsvpSearch.search(self, self.rsvpNumber, self.firstName, self.lastName, rsvp => {
        self.isSearching = false
        if (rsvp.isMtech) {
          self.error = {
            show: true,
            message: 'Tracking is not available for this reservation.'
          }
          return
        }
        if (rsvp.dispatchStatus === 'complete') {
          self.error = {
            show: true,
            message: self.$t('searchTrack.rsvpCompleted')
          }
          return
        }

        if (rsvp.dispatchStatus === 'canceled') {
          self.error = {
            show: true,
            message: self.$t('searchTrack.rsvpCancelled')
          }
          return
        }

        if (rsvp.hasExtraStop) {
          self.$sdk.get(self, `/reservations/${self.rsvpNumber}/${self.firstName}/${self.lastName}/extrastops`, {}, res => {
            if (!res.error) {
              rsvp.extraStops = res.list
              self.proceedToTrack(rsvp)
            }
          }, '1.1')
          return
        }

        let charterData = {
          enabled: false,
          pickup: {},
          startDate: '',
          endDate: '',
          selectedService: ''
        }
        if (rsvp.isCharter) {
          let starDate = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + ft.timeFormat(self, false))
          charterData = {
            enabled: true,
            pickup: rsvp.pickup,
            startDate: starDate.format('MM/DD/YYYY hh:mmA'),
            endDate: starDate.add(rsvp.eta, 'seconds').format('MM/DD/YYYY hh:mmA'),
            selectedService: rsvp.serviceCode
          }
        }
        self.$store.commit('reservation/setCharterData', charterData)

        if (rsvp.isAsap) {
          self.getAsapStatus(rsvp)
          return
        }

        if (rsvp.lyft && rsvp.lyft.webhookInfo) {
          rsvp.isLyft = true
          let lyftDriver = rsvp.lyft.webhookInfo.driver
          if (lyftDriver) {
            rsvp.provider.id = lyftDriver.id
            rsvp.provider.avatarUrl = lyftDriver.image_url
            rsvp.provider.firstName = lyftDriver.first_name
            rsvp.provider.lastName = ''
            rsvp.provider.rating = lyftDriver.rating
            rsvp.provider.email = lyftDriver.email || ''
            rsvp.provider.phones = [{
              countryCode: '',
              phoneNumber: lyftDriver.phone_number
            }]
          }
          let lyftVehicle = rsvp.lyft.webhookInfo.vehicle
          if (lyftVehicle) {
            rsvp.vehicle.photo = lyftVehicle.image_url
            rsvp.vehicle.manufacturer = lyftVehicle.make
            rsvp.vehicle.model = lyftVehicle.model
            rsvp.vehicle.plate = lyftVehicle.license_plate
          }
        }

        self.proceedToTrack(rsvp)
      }, error => {
        self.isSearching = false
        self.error = {
          show: true,
          message: self.$t('searchTrack.rsvpDoesntExist')
        }
        console.log(error)
      })
    },
    getVariable (url) {
      let query = window.location.search.substring(1);
      let vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] === url) {
          return pair[1]
        }
      }
      return false
    },
    checkShowOnLoad () {
      let brandData = Object.values(CONFIG.Brands).find((v) => {
        return parseInt(this._brandId, 10) === parseInt(v.id, 10)
      }) || false
      let firstPage = ['Search', 'SearchEdit', 'SearchTrack']
      document.body.classList.remove('widget-full')
      if (brandData) {
        this.showOnLoad = brandData.showOnLoad && firstPage.indexOf(this.route) > -1 ? 'show-on-load' : ''
      }
    },
    proceedToTrack (rsvp) {
      let self = this
      // if (self.$ga) {
      //   self.$ga.page({
      //     page: '/search-track',
      //     title: 'Track Page',
      //     screenName: 'track'
      //   })
      //   self.$ga.event({
      //     eventCategory: 'RSVP Track',
      //     eventAction: 'track',
      //     eventLabel: 'RSVP ' + self.rsvpNumber
      //   })
      // }
      // if (window.gtag) { // eslint-disable-line
      //   gtag('event', 'page_view', { // eslint-disable-line
      //     'page': 'Track page'
      //   })
      // }

      self.$store.commit('rsvpTrack/setRsvp', rsvp)
      // self.$router.push('rsvp-track')
      if (self.showOnLoad) {
        document.body.classList.add('widget-full');
      }
      if (self.getVariable('id')) {
        let cleanUri = location.protocol + '//' + location.host + location.pathname + window.location.hash
        window.history.replaceState({}, document.title, cleanUri)
      }

      if (window.opoliCNS) {
        let segment = {
          key: 'HomePage_Track',
          'Reservation Number': self.rsvpNumber,
          'First Name': self.firstName,
          'Last name': self.lastName
        }
        window.opoliCNS('events', {
          key: 'HomePage_Track',
          segment: segment,
          url: null,
          widgetEvent: true
        })
      }

      self.$root.$router.push('rsvp-track')
      window.location = '#/rsvp-track'
    },
    submitTrack (event) {
      if (event) event.preventDefault()
      if (this.$refs.submitBtn) {
        this.$refs.submitBtn.click()
      }
    },
    getAsapStatus (rsvp) {
      let self = this
      self.$sdk.get(self, `/reservations/${self.rsvpNumber}/${self.firstName}/${self.lastName}/asaptrack`, {}, r => {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message.replace('backend.', '')
          })
          return
        }
        if (['droppedOff', 'canceled'].indexOf(r.status) > -1) {
          let msg = self.$t('searchTrack.rsvpCompleted')
          if (['canceled', 'cancelled'].indexOf(r.status) > -1) msg = self.$t('searchTrack.rsvpCancelled')
          self.error = {
            show: true,
            message: msg
          }
          return
        }
        let driver = r.lyft.driver
        if (r.lyft.webhookInfo && r.lyft.webhookInfo.driver) driver = r.lyft.webhookInfo.driver
        rsvp.provider.ID = driver.id
        rsvp.provider.avatarUrl = driver.image_url
        rsvp.provider.email = ''
        rsvp.provider.firstName = driver.first_name
        rsvp.provider.lastName = ''
        rsvp.provider.rating = driver.rating
        rsvp.provider.phones = [
          {
            countryCode: '',
            phoneNumber: driver.phone_number.replace('+', '')
          }
        ]
        let vehicle = r.lyft.vehicle
        if (r.lyft.webhookInfo && r.lyft.webhookInfo.vehicle) vehicle = r.lyft.webhookInfo.vehicle
        rsvp.vehicle.photo = vehicle.image_url
        rsvp.vehicle.manufacturer = vehicle.make
        rsvp.vehicle.model = vehicle.model
        rsvp.vehicle.plate = vehicle.license_plate
        self.proceedToTrack(rsvp)
      })
    }
  },
  watch: {
    _brandId: function (value) { this.checkShowOnLoad() }
  },
  mounted () {
    let self = this
    // self.checkShowOnLoad()
    if (this.$route.name === 'SearchTrackDirect') {
      if (this.getVariable('id') && this.getVariable('fname') && this.getVariable('lname')) {
        this.rsvpNumber = decodeURIComponent(this.getVariable('id'))
        this.firstName = decodeURIComponent(this.getVariable('fname'))
        this.lastName = decodeURIComponent(this.getVariable('lname'))

        localStorage.setItem('trackId', this.rsvpNumber)
        localStorage.setItem('trackFname', this.firstName)
        localStorage.setItem('trackLname', this.lastName)

        setTimeout(function () {
          self.submit()
        }, 500)
      }
    } else {
      this.$router.push('/search')
    }
    // this.$store.commit('setCurrentIndex', -1)
    // this.$refs.ReservationNumberInput.focus()
    // window.dispatchEvent(new HashChangeEvent('hashchange'))
  }
}
</script>

<style lang="scss" scoped>
.abs-center-container {
  position: fixed;
  display: table;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  & .abs-center{
    display: table-cell;
    vertical-align: middle;
  }
  &.show-on-load{
    position: relative;
    display: block;
    text-align: left;

    .abs-center{ display: block; }
    .card{
      padding: 30px;
      border: none;
      box-shadow: none;
    }
  }
}

.card {
  max-width: 62.5rem;
  margin: 0 auto;
  border-radius: 3px;
  border: none;
  box-shadow: none;

  & h2 {
    font-size: 22px;
  }
}

.description {
  margin-bottom: 10px;
}

.error-message {
  background-color: #EB5837;
  color: #fff;
  padding: 5px;
  text-align: center;
  overflow: 0;
  transition: all 250ms;
  -webkit-transition: all 250ms;

  &.hide {
    height: 0;
    padding: 0 5px;
  }
}

.controls {
  margin-top: 10px;
  text-align: right;

  & .op-btn {
    width: 115px;
    height: 51px;
    text-align: center;
    vertical-align: middle;
  }

  & .btn-continue {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?66be412a